module.exports = __webpack_public_path__ + "static/media/baloon2.a0eaeae1.png";